import type { LeadRating } from '@/shared/types/domain';

const OPTIONS: { value: LeadRating; label: string }[] = [
  { value: 'Hot', label: '🔥 Hot' },
  { value: 'Warm', label: '☀ Warm' },
  { value: 'Cold', label: '❄ Cold' }
];

interface RatingSelectProps {
  value: LeadRating | null | undefined;
  onChange: (rating: LeadRating | null) => void;
}

export function RatingSelect({ value, onChange }: RatingSelectProps) {
  return (
    <div className="field">
      <label className="field__label" htmlFor="lead-rating">
        Lead rating
      </label>
      <select
        id="lead-rating"
        className="field__input"
        value={value ?? ''}
        onChange={(e) => onChange((e.target.value || null) as LeadRating | null)}
      >
        <option value="">No rating</option>
        {OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
